import {
  UserCircleIcon,
  ChevronRightIcon,
  EnvelopeIcon,
  Cog6ToothIcon,
  GlobeAltIcon,
  // MegaphoneIcon,
  // QuestionMarkCircleIcon,
  // CodeBracketSquareIcon,
} from '@heroicons/react/20/solid';

const menuGroup = [
  [
    {
      icon: <Cog6ToothIcon className='size-4' />,
      label: 'Settings',
    },
    {
      icon: <UserCircleIcon className='size-4' />,
      label: 'My Profile',
    },
    {
      icon: <EnvelopeIcon className='size-4' />,
      label: 'Question & Feedback',
    },
  ],
  [
    {
      icon: <GlobeAltIcon className='size-4' />,
      label: 'About',
    },
  ],
  // [
  //   {
  //     icon: <MegaphoneIcon className='size-4' />,
  //     label: 'Notices',
  //   },
  //   {
  //     icon: <QuestionMarkCircleIcon className='size-4' />,
  //     label: 'FAQ',
  //   },
  //   {
  //     icon: <CodeBracketSquareIcon className='size-4' />,
  //     label: 'Update Notes',
  //   },
  // ],
];

const Menu = ({ selectMenu }) => {
  return (
    <div className='space-y-2'>
      {menuGroup.map((group, i) => (
        <div
          key={i}
          className='rounded-xl px-3 py-2 bg-secondary'
        >
          {group.map((item) => (
            <div
              key={item.label}
              className='flex items-center justify-between py-2 text-white'
              onClick={selectMenu(item.label)}
            >
              <div className='flex items-center gap-2'>
                <span className='w-5'>{item.icon}</span>
                {item.label}
              </div>
              <ChevronRightIcon className='size-4' />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Menu;
